import { AimsCommonPopupEditorData } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-psc-reject-comment-dialog',
  templateUrl: './psc-reject-comment-dialog.component.html',
  styleUrls: ['./psc-reject-comment-dialog.component.css']
})
export class PscRejectCommentDialogComponent implements OnInit {

  public formGroup: any;

  constructor(contentData: AimsCommonPopupEditorData,) {

    this.formGroup = contentData.formGroup;

    this.formGroup.addControl('rejectionComment', new FormControl("", Validators.required));
    this.formGroup.addControl('sendRejectEmail', new FormControl(true, ));
  }

  ngOnInit(): void {
  }

}
